/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const teamHiringTimelineEntryDtoSchema = z.object({
  quarter: z.optional(z.string()),
  roles: z.optional(z.array(z.string())),
});
